import apiClient from 'src/utils/apiClient';

// **** Functions **** //

/**
 * Get list of austin cases the associate has access to.
 */
const fetchForAssociate = async (alias: string) => {
  return apiClient.get(`/incident/associate/${alias}`);
};

/**
 * Fetch a single austin case associate with the accommodation.
 */
const fetchForAccommodation = async (accommodationId: number) => {
  return apiClient.get(`/incident/accommodation/${accommodationId}`);
};

// **** Export **** //

export default {
  fetchForAssociate,
  fetchForAccommodation,
} as const;
